// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7899) return "static/chunks/7899-cbd744310971f680.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"165":"590caa2a","1015":"b2db8554","3132":"6139e184"}[chunkId] || chunkId) + "." + {"165":"8e920f38b1559163","1015":"8d606b69680f4acc","3132":"83f427bdd0b69a10","8727":"9bd0f6c465fd06a7"}[chunkId] + ".js";
};